import {
  Box,
  Button,
  Checkbox,
  TextField,
  Autocomplete,
  CircularProgress,
  Typography,
  Grid,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import axios from "axios";
import { useEffect, useState } from "react";
import { baseUrl } from "../../helper/urls";
import CounselorCard from "./CounselorCard"; // Use your display component
import GetStartedBanner from "./GetStartedBanner";
import BookFreeCounselingButton from "./BookFreeCounselingButton";
import StudentSidebar from "./studentSidebar/StudentSidebar";
import ReserveYouSpotModal from "./studentSidebar/ReserveYouSpotModal";
import { useSelector } from "react-redux";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function FilterCounselor() {
  const { token } = useSelector((state) => state.auth);
  const [universityList, setUniversityList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredCounselors, setFilteredCounselors] = useState([]);
  const [error, setError] = useState(null);

  // Filter states
  const [selectedServices, setSelectedServices] = useState([]);
  console.log(selectedServices);
  const [selectedUniversities, setSelectedUniversities] = useState([]);
  const [selectedPrices, setSelectedPrices] = useState(null);
  console.log(selectedUniversities);
  console.log(selectedPrices);

  const fetchUniversityList = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/counselors/getUniversityList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUniversityList(response.data.data || []);
    } catch (err) {
      console.error("Failed to load universities", err);
    }
  };

  const fetchCounselors = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(
        `${baseUrl}/api/counselors/approved/filter`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFilteredCounselors(response.data.data);
    } catch (err) {
      setError("Failed to load counselors. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    setLoading(true);
    setError(null);
    const price = {
      min: (selectedPrices && selectedPrices?.split("-")[0]) || null,
      max: (selectedPrices && selectedPrices?.split("-")[1]) || null,
    };
    try {
      const response = await axios.post(
        `${baseUrl}/api/counselors/approved/filter`,
        {
          services: selectedServices,
          // universities: selectedUniversities,
          interestedIn: selectedServices,
          universityName: selectedUniversities,
          price_per_hour: price,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFilteredCounselors(response?.data?.data || []);
    } catch (err) {
      setError("Failed to filter counselors");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCounselors();
    fetchUniversityList();
  }, []);

  return (
    <>
      {/* <Box
        display="flex"
        justifyContent="space-between"
        sx={{ padding: 2, width: "100%" }}
        alignItems="center"
        gap={2}
        // bgcolor="#f5f5f5"
        // flexWrap="wrap" // optional: allows wrapping on small screens
      >
        <Autocomplete
          multiple
          disableCloseOnSelect
          options={[
            "College Counseling",
            "Essay Counseling",
            "Essay + College Counseling",
          ]}
          getOptionLabel={(option) => option}
          value={selectedServices}
          onChange={(e, newValue) => setSelectedServices(newValue)}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                checked={selected}
              />
              {option}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Service Type"
              placeholder="Select services"
            />
          )}
          sx={{ width: 400 }}
        />

        <Autocomplete
          multiple
          disableCloseOnSelect
          options={universityList}
          getOptionLabel={(option) => option}
          value={selectedUniversities}
          onChange={(e, newValue) => setSelectedUniversities(newValue)}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                checked={selected}
              />
              {option}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="University Name"
              placeholder="Select universities"
            />
          )}
          sx={{ width: 400 }}
        />

        <Autocomplete
          options={[
            "50-100",
            "100-200",
            "200-500",
            // "300-400",
            // "400-500",
            // "500-600",
            // "600-700",
            // "700-800",
            // "800-900",
            // "900-1000",
          ]}
          value={selectedPrices}
          onChange={(e, newValue) => setSelectedPrices(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Price Range($)"
              placeholder="Select range"
            />
          )}
          sx={{ width: 400 }}
        />

        <Button
          variant="contained"
          color="primary"
          sx={{ height: 56, minWidth: 120 }}
          onClick={handleSearch}
        >
          Search
        </Button>
      </Box> */}

      {error && <Typography color="error">{error}</Typography>}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ display: "flex" }}>
          <Box>
            {/* <GetStartedBanner></GetStartedBanner> */}
            <CounselorCard counselors={filteredCounselors} />
            {/* <ReserveYouSpotModal /> */}
          </Box>
          <Box>
            <StudentSidebar />
          </Box>
        </Box>
      )}

      {/* <Box
        sx={{
          position: "fixed",
          bottom: 16,
          right: 209,
          zIndex: 1000,
        }}
      >
        <BookFreeCounselingButton />
      </Box> */}
    </>
  );
}
